// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"90":"9533048a","176":"c0b11390","444":"6b8122e4"}[chunkId] + ".chunk.css";
};